import React from 'react';

const LeaveDetailTable = ({ leaveBalance }) => {
  return (
    <div className="card end mt-3" style={{ width: '420px' }}>
      <table className="table table-sm table-bordered text-center mb-0">
        <thead className="table-light">
          <tr>
            <th>Leave</th>
            <th>Requested</th>
            <th>Consumed</th>
            <th>Available</th>
          </tr>
        </thead>

        <tbody>
          {/* Paid Leave */}
          <tr>
            <td>Paid</td>
            <td>{leaveBalance?.paid?.requested || 0}</td>
            <td>{leaveBalance?.paid?.consumed || 0}</td>
            <td>{leaveBalance?.paid?.available || 0}</td>
          </tr>

          {/* Saturday Leave */}
          <tr>
            <td>Saturday</td>
            <td>{leaveBalance?.saturday?.requested || 0}</td>
            <td>{leaveBalance?.saturday?.used || 0}</td>
            <td>{leaveBalance?.saturday?.available || 0}</td>
          </tr>

          {/* Unpaid Leave */}
          <tr>
            <td>Unpaid</td>
            <td>{leaveBalance?.unpaid?.requested || 0}</td>
            <td>{leaveBalance?.unpaid?.consumed || 0}</td>
            <td>∞</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LeaveDetailTable;